// extracted by mini-css-extract-plugin
export default {"mainContainerBox":"turningPage_mainContainerBox__n-X4M","turningContainer":"turningPage_turningContainer__nOrj9","turningNumber":"turningPage_turningNumber__IoEWj"};